import SingleFileupload from '@/components/common/fileupload/single/SingleFileupload.vue'
import DatePeriodPicker from '@/components/common/dateperiodpicker/DatePeriodPicker.vue'
import NumberInput from '@/components/common/numberinput/NumberInput.vue'
import { mapState } from 'vuex';

export default {
  name: 'ClientBillAttach',
  data () {
    return {
      loading: false,
      loadingBills: false,
      client: null,
      clientReport: null,
      editEl: {
        client: null,
        client_report_id: null,
        date_period_id: null,
        axaptCode: '',
        attachOrder: false,
        bill_number: '',
        axaptOrderNumber: null,
        files: [null],
        price_total: '',
        due_date: null
      },
      bills: [],
      sales: []
    }
  },
  components: {
    SingleFileupload,
    DatePeriodPicker,
    NumberInput
  },
  computed: {
    ...mapState(['config']),
    getTitle () {
      return this.$t('menu.bills.attach')
    },
    clientReportOptions () {
      const options = [];
      if (this.client && this.client.reports) {
        const self = this;
        const datePeriodId = parseInt(this.editEl.date_period_id);
        this.client.reports.forEach(el => {
          if (self.editEl.date_period_id === null || datePeriodId === el.date_period_id) {
            options.push({
              value: el.id,
              text: this.$options.filters.formatFromConfig(el.report_config_id, self.config.report_configs, 'name', this.$i18n.locale) + ' - ' +
                this.$tc('general.datePeriod.short', self.BasicHelper.datePeriodCodeToData(el.date_period_id).period, self.BasicHelper.datePeriodCodeToData(el.date_period_id))
            })
          }
        });
      }
      options.unshift({ value: null, text: '' });
      return options;
    }
  },
  methods: {
    show (data) {
      this.client = data.client;
      this.clientReport = data.clientReport;
      this.editEl.client = (data.client ? data.client.api_id : null);
      this.editEl.client_report_id = (data.clientReport ? data.clientReport.id : null);
      this.editEl.date_period_id = (data.clientReport ? data.clientReport.date_period_id : null);
      this.editEl.axaptCode = '';
      this.editEl.attachOrder = false;
      this.editEl.files = [null];
      this.editEl.axaptOrderNumber = null;
      this.editEl.bill_number = '';
      this.editEl.price_total = '';
      this.getBills();
      this.$refs['modal-window'].show();
    },
    getBills () {
      this.loadingBills = true;
      const self = this;
      this.ApiRequest.request('client-bill/axbills/' + this.client.api_id + '/missing', this.ApiRequest.REQUEST_GET, [], function (response) {
        if (response.data) {
          self.bills = response.data.bills;
          self.sales = response.data.sales;
          self.client = response.data.client;
        }
        self.loadingBills = false;
      });
    },
    save () {
      if (!this.loading) {
        this.loading = true;
        const reqData = this.ApiRequest.createFormData(this.editEl, Object.keys(this.editEl), 'bill', this);
        const self = this;
        this.ApiRequest.request('client-bill/axbills/' + this.client.api_id + '/attach', this.ApiRequest.REQUEST_FILEUPLOAD, reqData, function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self);
          } else {
            self.$emit('saved', response.data);
            self.close();
          }
          self.loading = false;
        });
      }
    },
    close () {
      this.$refs['modal-window'].hide();
    }
  }
}
